import { Box, Spread, Stack, Text } from '../../../components/DesignSystem'
import Formatter from '../../../helpers/Formatter'

type OrderTipSummaryProps = {
	prices: { total: number; tip: number }
}

export default function OrderTipSummary({ prices }: OrderTipSummaryProps) {
	return (
		<Box background="grayTranslucent" borderRadius="medium" padding="lg">
			<Stack gap="lg">
				<Spread>
					<Text>Total before tip</Text>
					<Text>{Formatter.currencyFormat(prices.total - prices.tip)}</Text>
				</Spread>

				<Spread>
					<Text>Tip</Text>
					<Text>{Formatter.currencyFormat(prices.tip) || 0}</Text>
				</Spread>

				<Spread>
					<Text level="subheadline" weight="semibold">
						Total
					</Text>
					<Text level="subheadline" weight="semibold" tone="positive">
						{Formatter.currencyFormat(prices.total)}
					</Text>
				</Spread>
			</Stack>
		</Box>
	)
}
